import { couponConstants } from '../constants';

export function coupons(state = {}, action) {
  switch (action.type) {
    case couponConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case couponConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case couponConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddCoupon(state = {}, action) {
  switch (action.type) {
    case couponConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case couponConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case couponConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetCoupon(state = {}, action) {
  switch (action.type) {
    case couponConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case couponConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case couponConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateCoupon(state = {}, action) {
  switch (action.type) {
    case couponConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case couponConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case couponConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}